module.exports = __webpack_public_path__ + "img/2.f5bdc5b8.png";